import * as React from 'react';
import { useEffect, useState } from 'react';
import Section, { SubSection } from "../../Commons/Section";
import DataFrame from "../../Commons/Components/DataFrame";
import { Row as DataFrameRow } from "../../Commons/Components/DataFrame/types";
import { useContent } from "../../Content/cms";
import Apirest from "../../Content/Apirest";

interface ScreeningScoreItem {
    screening: string;
    score?: number;
    show?: boolean;
}

interface ScreeningResultsProps {
    protocolResId: string;
}

const ScreeningResults: React.FC<ScreeningResultsProps> = ({ protocolResId }) => {

    let getContent = useContent();
    let [rows, setRows] = useState<DataFrameRow[]>([]);

    useEffect(() => {
        if (!protocolResId) return;
        Apirest.get_protocol_res_screening_scores(
            protocolResId,
            (response: ScreeningScoreItem[] | { results: ScreeningScoreItem[] }) => {
                const items: ScreeningScoreItem[] = Array.isArray(response)
                    ? response
                    : (response as any)?.results || [];

                const visibleItems = items.filter(item => item.show !== false);

                const mapped: DataFrameRow[] = visibleItems
                    .filter((item) => {
                        return typeof item.score === 'number';
                    })
                    .map((item) => {
                        const screeningKey = item.screening || '';
                        const nameKey = `protocol_result__screening__${screeningKey}__name`;
                        const explanationKey = `protocol_result__screening__${screeningKey}__explanation`;

                        const displayName = getContent(nameKey) || item.screening;

                        const rawScore = item.score;
                        const score = Math.round(rawScore as number);

                        const explanation = getContent(explanationKey) || '';

                        return [
                            <p className={'m-0 domain-name'}>{displayName}</p>,
                            <p className={'m-0 domain-score text-center'}>{score}</p>,
                            <p className={'m-0 domain-explanation'}>{explanation}</p>
                        ];
                    });

                setRows(mapped);
            }
        );
    }, [protocolResId]);

    if (rows.length === 0) return null;

    const header = [
        <p className={'m-0'}>{getContent('protocol_result__screening__header')}</p>,
        <p className={'m-0 text-center'}>{getContent('protocol_result__screening__header__score')}</p>,
        <p className={'m-0'}>{getContent('protocol_result__screening__header__explanation')}</p>
    ];

    return (
        <Section
            title={getContent('protocol_result__screening__title')}
            className={'secondary-section protocol-composite-section'}
            headerClassName={'secondary-section-header'}
            bodyClassName={'secondary-section-body'}
        >
            <SubSection title={''} className={'secondary-subsection'}>
                <DataFrame
                    header={header}
                    dataframe={rows}
                    className={'header-bordered mt-3 w-100'}
                    columnClassName={'align-middle'}
                    pageSize={rows.length + 1}
                    columnWidths={[25, 10, 65]}
                    sortableColumns={[]}
                />
            </SubSection>
        </Section>
    );
};

export default ScreeningResults;